import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatSliderModule} from '@angular/material/slider';
// import {MatRadioModule} from '@angular/material/radio';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatRippleModule} from '@angular/material/core';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSelectModule} from '@angular/material/select';
import {MatTabsModule} from '@angular/material/tabs';
import {PlatformModule} from '@angular/cdk/platform';
import {MatDialogModule} from '@angular/material/dialog';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatSliderModule,
    MatTooltipModule,
    MatInputModule,
    MatButtonModule,
    MatRippleModule,
    MatCheckboxModule,
    MatSelectModule,
    MatTabsModule,
    PlatformModule,
    MatDialogModule
  ],
  exports: [
    MatSliderModule/*,
    MatRadioModule*/,
    MatTooltipModule,
    MatInputModule,
    MatButtonModule,
    MatRippleModule,
    MatCheckboxModule,
    MatSelectModule,
    MatTabsModule,
    PlatformModule,
    MatDialogModule
  ]
})
export class SharedModule { }
